import React from "react";
import {
  Button,
  Drawer,
  Form,
  FormGroup,
  FormControl,
  CheckPicker,
  Schema,
  List,
  Radio,
  Col,
  Row,
  RadioGroup,
  Icon,
  Alert,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectDrawer } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import {
  selectCarsData,
  selectHoldOverCars,
} from "../../redux/cars/cars.selector";
import parsian from "../../assets/image/parsian.png";
import saman from "../../assets/image/saman.png";
import "./holdover.drawer.sass";
import {
  selectFormPeriod,
  selectFormPortal,
  selectHoldOverForm,
  selectLastPrice,
  selectReceivedForm,
} from "../../redux/form/form.selector";
import {
  ModifyLastPrice,
  SetFormPeriod,
  SetFormPortal,
  SetHoldOverForm,
  SetReceivedForm,
} from "../../redux/form/form.actions";
import {
  AddCarToHoldOverCars,
  SetHoldOverCars,
} from "../../redux/cars/cars.action";
import { removeItemFromHoldOver } from "../../redux/cars/cars.utils";
import carsTypes from "../../redux/cars/cars.types";
import { selectToken, selectUserInfo } from "../../redux/user/user.selector";
import Axios from "axios";
import { HandelShowPrice, PriceFormat, ToPersian } from "../../script";

class HoldoverDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FormValue: {
        cars: [],
        period: 12,
        mobile: "",
        name: "",
        family: "",
        portal: "saman",
      },
      CarSelected: [],
    };
  }
  componentWillUnmount() {
    const { setPeriod, setPortal, modifyLastPrice } = this.props;
    setPeriod(12);
    setPortal("");
    modifyLastPrice(null);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.holdoverCars !== this.props.holdoverCars) {
      this.setState({
        FormValue: {
          cars: this.props.holdoverCars,
          period: 0,
          mobile: "",
          name: "",
          family: "",
          portal: "saman",
        },
      });
    }
  }

  render() {
    const {
      ToggleDrawer,
      getDrawer,
      getCarsData,
      userInfo,
      getToken,
      setReceivedForm,
    } = this.props;
    const { FormValue } = this.state;

    const handleSubmit = (value) => {
      if (value) {
        let devices = [];
        this.state.FormValue.cars.map((item) => {
          devices = [...devices, { id: item, period: FormValue.period }];
        });

        console.log("NUMBER IS : ", userInfo.phone);

        if (!!userInfo.phone && userInfo.phone === "+989190191914") {
          Alert.error("شما قادر به تمدید پنل تست نیستید.", 4000);
          return;
        }

        let data = {
          phone: userInfo.phone,
          pass: userInfo.pass,
          mobile: "+98" + this.state.FormValue.mobile,
          devices: JSON.stringify(devices),
          name: this.state.FormValue.name,
          family: this.state.FormValue.family,
          type: this.state.FormValue.portal,
          os: "web",
        };

        Axios.post(`${getToken}/payment`, JSON.stringify(data)).then((res) => {
          if (res.data.success) {
            setReceivedForm(res.data.data.url);
            window.location.href = res.data.data.url;
          } else {
            Alert.error(
              "مشکلی در برقراری ارتباط به وجود آمده لطفا دوباره تلاش کنید"
            );
          }
        });
      } else {
        Alert.error("لطفا اطلاعات خود را بصورت صحیح تکمیل نمایید", 3000);
      }
    };

    const Title = ({ title }) => {
      return (
        <div className="hold-over-title">
          <Icon icon="circle" /> <span>{title}</span>
        </div>
      );
    };

    const { StringType, NumberType, ArrayType } = Schema.Types;

    const model = Schema.Model({
      name: StringType().isRequired("نام خود را وارد کنید"),
      family: StringType().isRequired("نام‌خانوادگی خود را وارد کنید"),
      mobile: NumberType().isRequired("لطفا شماره تلفن خود را وارد کنید"),
      period: NumberType().isRequired(),
      portal: StringType().isRequired(),
      cars: ArrayType()
        .minLength(1, "لطفا حداقل یک دستگاه برای تمدید انتخاب کنید")
        .isRequired("لطفا حداقل یک دستگاه برای تمدید انتخاب کنید"),
    });

    return (
      <div>
        <Drawer
          show={getDrawer}
          size={"xs"}
          onHide={() => ToggleDrawer()}
          className="hold-over-drawer"
        >
          <Form
            model={model}
            onChange={(value) => {
              this.setState({ FormValue: value });
            }}
            onSubmit={(value) => {
              handleSubmit(value);
            }}
            formValue={FormValue}
          >
            <Drawer.Body>
              <Title title="انتخاب دستگاه برای تمدید" />
              <FormControl
                accepter={CheckPicker}
                name="cars"
                block
                cleanable={false}
                placeholder="انتخاب کنید"
                data={getCarsData}
              />
              {FormValue.cars.length ? (
                <div>
                  <Title title={"دستگاه های انتخاب شده"} />
                  <div>
                    <List className="hold-over-list">
                      {FormValue.cars.length &&
                        FormValue.cars.map((item, index) => (
                          <List.Item
                            className="list-item"
                            key={index}
                            index={index}
                          >
                            <span
                              style={{ position: "relative", left: "100px" }}
                            >
                              {getCarsData.find((x) => x.DeviceID === item) ===
                              undefined
                                ? null
                                : getCarsData.find((x) => x.DeviceID === item)
                                    .Name}
                            </span>
                            <br />
                            <span>
                              <small
                                style={{ position: "relative", right: "50px" }}
                              >
                                DeviceID: {item}
                              </small>
                            </span>
                          </List.Item>
                        ))}
                    </List>
                  </div>
                </div>
              ) : null}
              <Title title={"انتخابه دوره اشتراک"} />
              <div className="holdOver-radios-div">
                <FormControl
                  name="period"
                  accepter={RadioGroup}
                  inline
                  className="radios-group"
                >
                  <Radio value={6}>۶ ماه</Radio>
                  <Radio value={12}>۱ سال</Radio>
                  <Radio value={24}>۲ سال</Radio>
                </FormControl>
              </div>
              <Title title={"مشخصات شما"} />
              <div className="hold-over-info-div">
                <FormGroup>
                  <Row>
                    <Col xs={12}>
                      <FormControl
                        type="text"
                        name="family"
                        placeholder="نام‌خانوادگی"
                        style={{ marginBottom: "5px" }}
                      />
                    </Col>
                    <Col xs={12}>
                      <FormControl
                        type="text"
                        name="name"
                        placeholder="نام"
                        style={{ marginBottom: "5px" }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormControl
                        type="number"
                        name="mobile"
                        placeholder="تلفن همراه"
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </div>
              <Title title={"درگاه پرداخت"} />
              <div className="holdOver-radios-div">
                <FormControl
                  name="portal"
                  accepter={RadioGroup}
                  className="bank-radios"
                  style={{ padding: "5px 10px" }}
                >
                  <Radio value="saman">
                    {" "}
                    <img src={saman} alt="bank saman portal" /> بانک سامان
                  </Radio>
                  <Radio value="parsian">
                    {" "}
                    <img src={parsian} alt="bank parsian portal" /> بانک پارسیان
                  </Radio>
                </FormControl>
              </div>
            </Drawer.Body>
            <>
              {getCarsData && (
                <Drawer.Footer style={{ position: "relative", bottom: "13px" }}>
                  {FormValue.cars.length &&
                  FormValue.period &&
                  FormValue.mobile &&
                  FormValue.name ? (
                    <Button type="submit" size="lg" className="Btn1" block>
                      <Row>
                        <Col xs={12}>
                          <span>
                            {ToPersian(
                              PriceFormat(
                                HandelShowPrice(
                                  getCarsData,
                                  FormValue.cars,
                                  FormValue.period
                                )
                              )
                            )}{" "}
                            تومان
                          </span>
                        </Col>
                        <Col xs={12}>پرداخت</Col>
                      </Row>
                    </Button>
                  ) : FormValue.cars.length && FormValue.period ? (
                    <Button type="submit" size="lg" block disabled>
                      <Row>
                        <Col xs={12}>
                          <span>
                            {ToPersian(
                              PriceFormat(
                                HandelShowPrice(
                                  getCarsData,
                                  FormValue.cars,
                                  FormValue.period
                                )
                              )
                            )}{" "}
                            تومان
                          </span>
                        </Col>
                        <Col xs={12}>پرداخت</Col>
                      </Row>
                    </Button>
                  ) : (
                    <Button block disabled>
                      <span>پرداخت</span>
                    </Button>
                  )}
                </Drawer.Footer>
              )}
            </>
          </Form>
          <div id="formState" />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  getDrawer: selectDrawer,
  // getCarInfo: selectSelectedCarInfo,
  holdoverCars: selectHoldOverCars,
  getPortal: selectFormPortal,
  getPeriod: selectFormPeriod,
  getCarsData: selectCarsData,
  selectHoldOverForm: selectHoldOverForm,
  getLastPrice: selectLastPrice,
  userInfo: selectUserInfo,
  getToken: selectToken,
  receivedForm: selectReceivedForm,
});
const mapDispatchToProps = (dispatch) => ({
  ToggleDrawer: () => dispatch({ type: modalsTypes.TOGGLE_DRAWER }),
  setPortal: (portal) => dispatch(SetFormPortal(portal)),
  setPeriod: (period) => dispatch(SetFormPeriod(period)),
  addCarToHoldOverCar: (car) => dispatch(AddCarToHoldOverCars(car)),
  RemoveItemFromHoldOver: (car) => dispatch(removeItemFromHoldOver(car)),
  ClearHoldOvercars: () => dispatch({ type: carsTypes.CLEAR_HOLDOVER_CARS }),
  SetHoldOverForm: (form) => dispatch(SetHoldOverForm(form)),
  setHoldOverCar: (data) => dispatch(SetHoldOverCars(data)),
  modifyLastPrice: (price) => dispatch(ModifyLastPrice(price)),
  setReceivedForm: (Form) => dispatch(SetReceivedForm(Form)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HoldoverDrawer);
